module.exports = __webpack_public_path__ + "static/media/iconoFlechaAbajoGris.17e1492e.svg";